import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { api, formatApiError, formatPrice } from "../../lib/api";
import { ProductForm } from "./ProductForm";

export const AdminProducts = ({ onChange }) => {
  const [products, setProducts] = useState([]);
  const [editing, setEditing] = useState(undefined);

  const load = () => api.get("/products").then((r) => setProducts(r.data));
  useEffect(() => { load(); }, []);

  const del = async (p) => {
    if (!window.confirm(`Supprimer « ${p.name} » ?`)) return;
    try { await api.delete(`/products/${p.id}`); toast.success("Produit supprimé"); load(); onChange(); }
    catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div data-testid="admin-products">
      <div className="flex items-center justify-between">
        <p className="text-sm text-slate-500">{products.length} produit(s)</p>
        <button data-testid="admin-add-product-button" onClick={() => setEditing(null)} className="btn-primary"><Plus className="h-4 w-4" /> Ajouter un produit</button>
      </div>
      <div className="mt-6 overflow-x-auto border border-navy/10 bg-white">
        <table className="w-full text-sm">
          <thead className="bg-ice text-left font-mono text-[11px] uppercase tracking-widest text-slate-500">
            <tr><th className="p-4">Produit</th><th className="p-4">Catégorie</th><th className="p-4">Prix</th><th className="p-4">Stock</th><th className="p-4 text-right">Actions</th></tr>
          </thead>
          <tbody className="divide-y divide-navy/10">
            {products.map((p) => (
              <tr key={p.id} data-testid={`admin-product-row-${p.id}`} className="hover:bg-ice/60">
                <td className="p-4"><div className="flex items-center gap-3"><img src={p.image} alt="" className="h-10 w-10 object-cover bg-ice" /><span className="font-semibold text-navy">{p.name}</span>{p.featured && <span className="bg-gold px-1.5 py-0.5 font-mono text-[9px] uppercase text-navy">Sélection</span>}</div></td>
                <td className="p-4 text-slate-600">{p.category}</td>
                <td className="p-4 font-semibold text-navy">{formatPrice(p.price)}</td>
                <td className={`p-4 ${p.stock <= 0 ? "text-red-500" : "text-slate-600"}`}>{p.stock}</td>
                <td className="p-4">
                  <div className="flex justify-end gap-2">
                    <button data-testid={`admin-edit-${p.id}`} onClick={() => setEditing(p)} className="grid h-9 w-9 place-items-center border border-navy/15 hover:border-royal hover:text-royal"><Pencil className="h-4 w-4" /></button>
                    <button data-testid={`admin-delete-${p.id}`} onClick={() => del(p)} className="grid h-9 w-9 place-items-center border border-navy/15 hover:border-red-500 hover:text-red-500"><Trash2 className="h-4 w-4" /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {editing !== undefined && (
        <ProductForm key={editing?.id || "new"} product={editing} open onClose={() => setEditing(undefined)} onSaved={() => { setEditing(undefined); load(); onChange(); }} />
      )}
    </div>
  );
};
